/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useMediaQuery } from '@/Hooks/useMediaQuery/useMediaQuery';
import useWebinarApi from '@/Hooks/WebinarApi/useWebinarApi';
import Pagination from '../../Games/Pagination';
import CCLoader from '@/Atoms/CCLoader/CCLoader';
import CCPackageTable from '@/Atoms/CCPackageTable';
import CCText from '@/Atoms/CCText';
import Box from '@/Atoms/Box';
import Spacer from '@/Atoms/Spacer';
import {
  ScrollView,
  Pressable,
  Image,
  Linking,
  StyleSheet,
  View,
  ActivityIndicator,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import CCColors from '@/Utils/CCColors';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import { FontSizes, hs, vs } from '@/Utils/Dimensions';
import CCButton from '@/Atoms/CCButton/CCButton';
import { TouchableOpacity } from 'react-native-gesture-handler';
import {
  convertISTDateTimeToLocal,
  convertISTToUserTimezone,
  getUTCOffset,
  openInNewTab,
  setLocalStorage,
  getRouteMap,
  getValidTimezone,
  getLocalStorage,
} from '@/Utils/CommonUtils';
import useWebinarHeldApi from '@/Hooks/WebinarApi/useWebinarHeldApi';
import useCancelSessionApi from '@/Hooks/WebinarApi/useCancelSessionApi';
import SlideModal from '@/Atoms/SlideModal';
import { PopUp } from '@/Screens/Visualisation/components/LevelModal';
import { ActiveMeetingsModal } from './ActiveMeetingsModal';
import { CancelSessionModal } from './CancelSessionModal';
import RenewalExpiryModal from './RenewalExpiryModal';
import useClassroomJoin from '@/Hooks/ClassroomInfoApi/useClassroomJoin';
import LinkModal from './LinkPopup';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import MeetingsBanner from './MeetingsBanner';
import RenewalBanner from '@/Screens/Renewal/components/RenewalBanner';
import useGetRenewalForUser from '@/Hooks/RenewalApi/useGetRenewalForUser';
import { ScreenName } from '@/navigators/StackConstants';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { loadChallengeState } from '@/Screens/RenewalPuzzleChallenge/utils';
import { PersistedChallengeState } from '@/Screens/RenewalPuzzleChallenge/types';
import { TabBar, TabView } from 'react-native-tab-view';
import { Picker } from '@react-native-picker/picker';
import dayjs from 'dayjs';
import { getStatusStyles } from './MentorCalls';
import useCTActionApi from '@/Hooks/CTActionApi/CTActionApi';
import RescheduleModal, { AvailableSlots } from './RescheduleModel';
import useCoachAvailabilitySlots from '@/Hooks/WebinarApi/useCoachAvailableSlots';
import useRescheduleSessionApi from '@/Hooks/WebinarApi/useRescheduleSession';
import useGetAvailableSlots from '@/Hooks/MentorCallsApi/getAvailableSlots';
import useRescheduleMentorCall from '@/Hooks/MentorCallsApi/rescheduleMentorCall';
import Divider from '@/Atoms/Divider/Divider';
import { LinearGradient } from 'expo-linear-gradient';
import Tooltip from '@/Atoms/Tooltip';
import bookOpen from '../../../Assets/Images/Svgs/book-open.svg';
import bookCheck from '../../../Assets/Images/Svgs/book-check.svg';
import useAlertModalStore from '@/Store/AlertModalStore';
import useResumeCsocSubscription from '@/Hooks/SubscriptionApi/useResumeCsocSubscription';
import useGetCsocSubscriptionDetailsApi from '@/Hooks/SubscriptionDetails/useCsocSubscription';
import SupportModal from '@/Components/UserAssistance/component/SupportModal';
import EmptyView from './EmptyView';
import useRestrictClassModalStore from '@/Store/RestrictClassModalStore';
import ClassReviewModal from './ClassReviewModal';
import { useQueryClient } from '@tanstack/react-query';
import useUpdateProfileApi from '@/Hooks/ProfileApi/profileUpdateApi';

// const tabHeadersWithClassroom = [
//   'Webinar topic',
//   'Coach',
//   'Class Type',
//   'Webinar date',
//   'Webinar time',
//   'Classroom',
//   'Webinar URL',
// ];

const isInternationalUser = (mobileNumber: string): boolean => {
  if (!mobileNumber) {
    return false;
  }
  const normalized = mobileNumber.trim().replace(/\s+/g, '');
  return !normalized.startsWith('+91') && !normalized.startsWith('91');
};
// ---------------------------------------------------------------------------
// CSOC tournament row colour.
//
// Tournament rows in the Meetings table are tinted so they read as a different
// row type from the classes around them. Three options below — swap which one
// TOURNAMENT_ROW_BG points at to change the look. Constraint: it has to stay
// clearly distinct from the two tints already in this table — the yellow
// today-highlight (CCColors.HighlightColor, #f9e9b599) and the light-red
// critical row (CCColors.WrongMoves.Background).
//
//   lavender — cool + calm, furthest from the existing yellow/red tints
//   mint     — cool + "go", pairs with the teal used elsewhere in the app
//   cream    — warmest, quietest; closest to the table's own #FAF6EB banding
// ---------------------------------------------------------------------------
export const TOURNAMENT_ROW_BG_OPTIONS = {
  lavender: '#F3EEFF',
  mint: '#E8F7F4',
  cream: '#FFF6E3',
};
export const TOURNAMENT_ROW_BG = TOURNAMENT_ROW_BG_OPTIONS.mint;

export const ICON_MAP = {
  warning: {
    name: 'exclamation',
    bgColor: CCColors.WrongMoves.Background,
    iconColor: CCColors.RedBg,
  },
  info: { name: 'information-variant', bgColor: CCColors.Primary.Dark },
  error: {
    name: 'close',
    bgColor: CCColors.WrongMoves.Background,
    iconColor: CCColors.RedBg,
  },
  alert: {
    name: 'exclamation-thick',
    bgColor: CCColors.WrongMoves.Background,
    iconColor: CCColors.RedBg,
  },
};

const ThankYouModal = ({ visible, onClose }) => {
  return (
    <SlideModal
      visible={visible}
      type="center"
      onClose={onClose}
      customStyle={{ width: 300 }}>
      <View style={styles.container}>
        <View style={styles.iconWrapper}>
          <Icon
            name="check-circle"
            size={48}
            color={CCColors.Rewards.TextRed}
          />
        </View>
        <CCText fontSize={FontSizes[20]} style={styles.title}>
          Thank you!
        </CCText>
        <CCText fontSize={FontSizes[14]} style={styles.subtitle}>
          Your feedback helps us improve the learning experience for every
          student.
        </CCText>
        <View style={styles.divider} />
        <CCText fontSize={FontSizes[13]} style={styles.note}>
          Our team reviews every response carefully.
        </CCText>
        <CCButton
          style={styles.button}
          onPress={onClose}
          titleStyle={{ fontSize: FontSizes[15] }}>
          Done
        </CCButton>
      </View>
    </SlideModal>
  );
};

const Meetings: React.FC<any> = ({
  userKey,
  userContact,
  userData: propUserData,
  setUserData: propSetUserData,
  setPopupBlocked,
  banner,
}) => {
  const globalUserData = useLoggedInUserStore(state => state.userData);
  const setGlobalUserData = useLoggedInUserStore(state => state.setUserData);
  const userData = globalUserData || propUserData;

  const queryClient = useQueryClient();
  const [showTimezoneBanner, setShowTimezoneBanner] = useState(false);
  const [timezoneMismatchShown, setTimezoneMismatchShown] = useState(false);

  const { mutate: updateProfile, isLoading: isUpdatingProfile } = useUpdateProfileApi(
    (response) => {
      setShowTimezoneBanner(false);
      queryClient.invalidateQueries(['dashboard']);
      fetchMeetings();
    },
    () => {
      setShowTimezoneBanner(false);
    }
  );

  const handleSwitchTimezone = () => {
    const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const list = userData?.user_timezone?.list || [];
    const normalizeTz = (tz: string) => (tz === 'Asia/Calcutta' ? 'Asia/Kolkata' : tz);
    const normalizedLocal = normalizeTz(localTz);
    const match = list.find((tz: any) => tz.value === normalizedLocal || tz.label.includes(normalizedLocal));
    const targetLabel = match ? match.label : localTz;
    const getValueOrEmptyString = (value: any) => (value && String(value).trim().length > 0) ? String(value) : '';

    updateProfile({
      first_name: getValueOrEmptyString(userData?.first_name),
      last_name: getValueOrEmptyString(userData?.last_name),
      email: getValueOrEmptyString(userData?.email),
      pincode: getValueOrEmptyString(userData?.pincode),
      mobile_number: getValueOrEmptyString(userData?.mobile_number),
      alternate_mobile_number: getValueOrEmptyString(userData?.alternate_mobile_number),
      fide_id: getValueOrEmptyString(userData?.fide_id),
      lic_name: getValueOrEmptyString(userData?.lic_name),
      cdc_name: getValueOrEmptyString(userData?.cdc_name),
      username: getValueOrEmptyString(userData?.username),
      player_type: userData?.player_type || 1,
      user_timezone: targetLabel,
      banner_log: { banner: 'timezone_mismatch', source: 'meetings_tab', platform: 'web' },
    }, {
      onSuccess: (data: any) => {
        if (data?.success) {
          const newUserData = {
            ...userData,
            user_timezone: {
              ...userData?.user_timezone,
              selected: targetLabel
            }
          };

          setGlobalUserData(newUserData);

          if (propSetUserData) {
            propSetUserData(newUserData);
          }

          getLocalStorage('user_details').then((stored) => {
            if (stored) {
              try {
                const parsed = JSON.parse(stored);
                if (!parsed.user_timezone) parsed.user_timezone = {};
                parsed.user_timezone.selected = targetLabel;
                setLocalStorage('user_details', JSON.stringify(parsed), true);
              } catch (e) { }
            }
          });
        }
      }
    });
  };

  // Detect user timezone (fallback to IST)
  const TWO_HOURS = 2 * 60 * 60 * 1000;
  const lastFetchRef = useRef<number>(Date.now());
  const isFetchingRef = useRef<boolean>(false);

  const userTimezone = userData?.user_timezone?.selected || 'Asia/Kolkata';
  const [webinarLoading, setWebinarLoading] = useState(true);
  const [webinarData, setWebinarData] = useState([]);
  const [pastWebinarData, setPastWebinarData] = useState([]);
  // Upcoming CSOC tournaments the student is eligible for. Kept in its own
  // array — these rows are formatted separately and appended to
  // upcomingTableData, never merged into webinarData (they have no end_time /
  // join_url and would break that row renderer).
  const [tournamentData, setTournamentData] = useState<any[]>([]);
  const [webinarDetails, setWebinarDetails] = useState([]);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [sessionClick, setSessionClick] = useState(false);
  const [pastWebinarId, setPastWebinarId] = useState(null);
  const [popupText, setPopupText] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelSessionData, setCancelSessionData] = useState<any>(null);
  const [index, setIndex] = useState(0);
  const [isTabChanging, setIsTabChanging] = useState(false);
  console.log('webinarDetails: ', webinarDetails);
  const [showStatusBar, setShowStatusBar] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [pendingJoinData, setPendingJoinData] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const [statusBarData, setStatusBarData] = useState(null);
  const [pausedOrderId, setPausedOrderId] = useState('');
  const [toRoute, setRoute] = useState<(() => void) | null>(null);
  const [toRoute1, setRoute1] = useState<(() => void) | null>(null);
  const [toRoute2, setRoute2] = useState<(() => void) | null>(null);
  const [action1, setAction1] = useState('');
  const [action2, setAction2] = useState('');
  const [todayWebinarIds, setTodayWebinarIds] = useState<Set<string>>(
    new Set(),
  );
  const [callId, setCallId] = useState('');
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [isMentorCall, setIsMentorCall] = useState(false);
  const [coachAvailableSlots, setCoachAvailableSlots] =
    useState<AvailableSlots>();
  const openAlertModal = useAlertModalStore(state => state.openModal);
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState(false);
  const [rescheduleSessionResponse, setRescheduleSessionResponse] =
    useState<any>();
  // const [visible, setVisible] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [meetingRole, setMeetingRole] = useState('');
  // const [showRenewalBanner, setShowRenewalBanner] = useState(false);
  const [challengeState, setChallengeState] =
    useState<PersistedChallengeState | null>(null);
  const [showRenewalModal, setShowRenewalModal] = useState(false);
  const [renewalModalData, setRenewalModalData] = useState<{
    days_to_expiry: number | null;
    state: 'normal' | 'warning' | 'urgent' | 'expired';
  } | null>(null);
  // console.log('userData: ', userData.is_staff);
  const [zeroMeetingData, setZeroMeetingData] = useState([]);
  // Get renewal data for banner - user ID extracted from auth token
  // const {data: renewalData, isLoading: isLoadingRenewal} =
  //   useGetRenewalForUser();
  const [showModal, setShowModal] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const {
    showRestrictClassModal,
    setShowRestrictClassModal,
    showJoinStatusMessage,
  } = useRestrictClassModalStore();
  // Show renewal banner if eligible (but hide for international users)
  // useEffect(() => {
  //   if (renewalData?.banner?.should_show) {
  //     // Check if user is international - hide banner if so
  //     const mobileNumber = renewalData?.user?.mobile || userContact;
  //     if (mobileNumber && !userData.is_coach) {
  //       setShowRenewalBanner(false);
  //     } else {
  //       setShowRenewalBanner(true);
  //     }
  //     // Read challenge state from localStorage for this user
  //     const stored = loadChallengeState(userData?.user_id ?? 'guest');
  //     setChallengeState(stored);
  //   }
  // }, [renewalData, userContact]);

  // // Re-read challenge state from localStorage every time this screen comes into focus
  // // (user may have just completed the puzzle challenge and returned)
  useFocusEffect(
    useCallback(() => {
      const stored = loadChallengeState(userData?.user_id ?? 'guest');
      setChallengeState(stored);

      const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const profileTzRaw = userData?.user_timezone?.selected;
      const hasMeetings = (webinarData?.length ?? 0) > 0 || (pastWebinarData?.length ?? 0) > 0;
      if (profileTzRaw && hasMeetings) {
        const profileTz = getValidTimezone(profileTzRaw);

        // Compare actual UTC offsets, not zone names — e.g. Asia/Calcutta and
        // Asia/Colombo are different IANA names but the same +05:30 offset,
        // so meeting times would display correctly either way; that's not a
        // real mismatch worth bothering the user about.
        const localOffset = dayjs().tz(localTz).utcOffset();
        const profileOffset = dayjs().tz(profileTz).utcOffset();

        if (localOffset !== profileOffset && !timezoneMismatchShown) {
          setShowTimezoneBanner(true);
          setTimezoneMismatchShown(true);
        }
      }
    }, [
      userData?.user_id,
      userData?.user_timezone?.selected,
      timezoneMismatchShown,
      webinarData,
      pastWebinarData,
    ]),
  );

  const tabHeaders = [
    'Date',
    `Topic & ${meetingRole === 'coach' ? 'Session Number' : 'Coach'}`,
    'Time',
    'Class Type',
    'Status',
    // 'Classroom',
    '', // contains button and cancel x
  ];
  // Define your color array
  const STATUS_BAR_COLORS = [
    CCColors.StatusBar.PinkShade,
    CCColors.StatusBar.Blue,
    CCColors.StatusBar.Orange,
    CCColors.StatusBar.Green,
  ];
  const TEXT_COLORS = [
    CCColors.StatusBar.DarkPink,
    CCColors.StatusBar.DarkBlue,
    CCColors.Red,
    CCColors.Green,
  ];
  // In your component
  const [colorIndex, setColorIndex] = useState(2);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setColorIndex(prevIndex => (prevIndex + 1) % STATUS_BAR_COLORS.length);
  //   }, 500); // Change color every 3 seconds

  //   return () => clearInterval(interval);
  // }, []);

  const [statusBanner, setStatusBanner] = useState({
    icon: 'information-outline',
    iconBg: '',
    title: '',
    subTitle: '',
    ctaTitle: '',
    closeIcon: false,
    iconColor: '',
    id: 0,
    ctaAction: '',
    link: '',
    highlight: 0,
  });
  const [popupConfig, setPopupConfig] = useState({
    icon: 'information-outline',
    questionText: '',
    subQuestionText: '',
    cta1: {
      text: '',
      highlight: false,
      link: '',
    },
    cta2: {
      text: '',
      highlight: false,
      link: '',
    },
    id: 0,
  });
  const navigation = useNavigation();

  const handleConfirmJoin = () => {
    if (pendingJoinData) {
      // console.log(pendingJoinData, 'pendingJoinData');

      const opened = handleJoinClick(pendingJoinData); // ✅ only runs when Confirm is clicked
      if (opened === false) {
        setPopupBlocked(true);
      } else {
        setPendingJoinData(null);
      }
    }
    setShowPopup(false);
  };
  const ROUTE_MAP = getRouteMap(navigation, {
    user_raised_issues: () => setShowModal(true),
  });

  const handleCTA1Press = () => {
    if (toRoute1) {
      toRoute1();
      setShowPopup(false);
    } else if (action1 === 'continue_join') {
      handleConfirmJoin();
    } else if (action1 === 'link') {
      window.open(popupConfig?.cta1?.link, '_blank');
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
    popupAction({
      popup_id: popupConfig?.id,
      mobile_number: userContact,
      cta_action: action1,
    });
  };
  const handleCTA2Press = () => {
    if (toRoute2) {
      toRoute2();
      setShowPopup(false);
    } else if (action2 === 'continue_join') {
      handleConfirmJoin();
    } else if (action2 === 'link') {
      window.open(popupConfig?.cta2?.link, '_blank');
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
    popupAction({
      popup_id: popupConfig?.id,
      mobile_number: userContact,
      cta_action: action2,
    });
  };
  const routes = [
    { key: 'Meetings', title: 'Meetings' },
    { key: 'Upcoming Meetings', title: 'Upcoming Meetings' },
  ];
  // Use shared classroom join hook
  const {
    showActiveMeetingsModal,
    activeMeetingsCount,
    activeLoading,
    endLoading,
    handleJoinClick,
    handleModalClose,
    handleModalJoin,
    handleModalEndAndJoin,
  } = useClassroomJoin();

  const handleOnSuccessWebinarDetails = data => {
    setWebinarData(data?.data?.webinar_list);
    setPastWebinarData(data?.data?.past_webinar_list);
    // Older backends do not send this key — default so the tab still renders.
    setTournamentData(data?.data?.tournament_list || []);
    setWebinarDetails(data?.data);
    setZeroMeetingData(data?.data?.zero_meeting);
    setWebinarLoading(false);
    setPopupData(data?.data?.popup_message);
    setStatusBarData(data?.data?.status_message);

    // Handle renewal info - show modal if present
    const renewalInfo = data?.data?.renewal_info;
    if (renewalInfo?.needs_renewal && !userData.is_coach) {
      setRenewalModalData({
        days_to_expiry: renewalInfo.days_to_expiry,
        state: renewalInfo.state,
      });
      setShowRenewalModal(true);
    } else {
      setRenewalModalData(null);
      setShowRenewalModal(false);
    }
  };
  useEffect(() => {
    if (statusBarData) {
      setShowStatusBar(true);
      setRoute(() => ROUTE_MAP[statusBarData?.cta_details?.[0]?.action]);
      const iconConfig = ICON_MAP?.[statusBarData?.icon] ?? {};
      setStatusBanner({
        icon: iconConfig?.name,
        iconBg: iconConfig?.bgColor,
        title: statusBarData?.main_text
          ? statusBarData.main_text.charAt(0).toUpperCase() +
          statusBarData.main_text.slice(1)
          : '',
        subTitle: statusBarData?.sub_text
          ? statusBarData.sub_text.charAt(0).toUpperCase() +
          statusBarData.sub_text.slice(1)
          : '',
        ctaTitle: statusBarData?.cta_details?.[0]?.text || '',
        ctaAction: statusBarData?.cta_details?.[0]?.action || '',
        closeIcon: statusBarData?.close_icon,
        iconColor: CCColors.White,
        id: statusBarData?.id,
        link: statusBarData?.cta_details?.[0]?.link || '',
        highlight: statusBarData?.cta_details?.[0]?.highlight || 0,
      });
    }
  }, [statusBarData]);
  const handleOnSuccessWebinarHeld = data => {
    console.log('marked successfully', data);
    if (data?.data?.success) {
      setPastWebinarData(prev =>
        prev.filter(item => item?.id !== pastWebinarId),
      );
    } else {
      setShowErrorAlert(true);
      setPopupText('Please try again later');
    }
  };
  const handleOnErrorWebinarUnheld = error => {
    console.log('error in marking webinar held', error);
    if (error) {
      setShowErrorAlert(true);
      setPopupText(error?.response?.data?.error);
    }
  };
  const { mutate: getWebinarDetails, isLoading: isWebinarLoading } =
    useWebinarApi(handleOnSuccessWebinarDetails);
  const { mutate: markWebinarHeld, isLoading } = useWebinarHeldApi(
    handleOnSuccessWebinarHeld,
    handleOnErrorWebinarUnheld,
  );
  const { mutate: popupAction } = useCTActionApi(() => {
    console.log('Popup action updated successfully!');
  });

  const { mutate: getPausedCsocOrder } = useGetCsocSubscriptionDetailsApi(
    (data: any) => {
      const paused = (data?.data ?? []).find(
        (order: any) => order?.status?.toLowerCase() === 'paused',
      );
      setPausedOrderId(paused?.order_id ?? '');
    },
    () => { },
  );

  const { mutate: resumeSubscription, isLoading: isResuming } =
    useResumeCsocSubscription(
      () => {
        setShowStatusBar(false);
        setStatusBarData(null);
        setPausedOrderId('');
        fetchMeetings();
        if (userData?.user_id) {
          getPausedCsocOrder({ userId: userData.user_id, source: 'meetings_tab', platform: 'web' });
        }
      },
      (error: any) => {
        openAlertModal({
          header: 'Error',
          bodyTxt:
            error?.response?.data?.detail ||
            error?.response?.data?.message ||
            error?.message ||
            'Failed to resume subscription. Please try again.',
          buttonText: 'OK',
          handleConfirmation: () => { },
        });
      },
    );

  useEffect(() => {
    if (userData?.user_id) {
      getPausedCsocOrder({ userId: userData.user_id, source: 'meetings_tab', platform: 'web' });
    }
  }, [userData?.user_id]);

  const handleResumeFromBanner = () => {
    if (!pausedOrderId || isResuming) {
      return;
    }
    openAlertModal({
      header: 'Confirm',
      bodyTxt: 'Are you sure you want to resume this subscription?',
      buttonText: 'Yes, resume',
      cancelText: 'Cancel',
      handleConfirmation: () => {
        resumeSubscription({ order_id: pausedOrderId, source: 'meetings_tab', platform: 'web' });
      },
      handleCancel: () => { },
    });
  };

  const handleOnSuccessCancelSession = data => {
    console.log('Session cancelled successfully', data);
    if (data?.data?.success) {
      // Close the modal and show success message
      setShowCancelModal(false);
      setCancelSessionData(null);
      setPopupText('Session cancelled successfully');
      setShowErrorAlert(true);

      // Refetch the webinar list to get updated data including finding_substitute flag
      getWebinarDetails({ user_key: userKey, timezone: getUTCOffset() });
    } else {
      setShowErrorAlert(true);
      setPopupText(data?.data?.message || 'Failed to cancel session');
    }
  };

  const handleOnErrorCancelSession = error => {
    console.log('error in cancelling session', error);
    if (error) {
      setShowErrorAlert(true);
      setPopupText(
        error?.response?.data?.message || 'Failed to cancel session',
      );
    }
  };

  const { mutate: cancelSession, isLoading: isCancelling } = useCancelSessionApi(
    handleOnSuccessCancelSession,
    handleOnErrorCancelSession,
  );

  const handleCancelClick = (item: any) => {
    // Determine cancellation type based on batch_code
    // Personal sessions: batch_code contains '-p-' OR call_type is 'mentor_call'
    // Group sessions: batch_code exists but doesn't contain '-p-'
    const isPersonal =
      (item?.batch_code && item?.batch_code?.toLowerCase()?.includes('-p-')) ||
      item?.call_type === 'mentor_call' ||
      item?.class_type == 'ptm';
    const cancellationType = isPersonal ? 'personal' : 'group';

    // Determine user role (coach vs student/parent)
    const userRole =
      item?.user_type === 'coach' || item?.user_role === 'mentor'
        ? 'coach'
        : 'student';
    setUserRole(userRole);
    setCancelSessionData({
      id: item?.id,
      topic: item?.topic,
      date: item?.webinar_date,
      time: item?.webinar_time,
      cancellation_type: cancellationType,
      user_type: item?.user_type, // Store user type for role determination
      batch_code: item?.batch_code || '', // Pass batch code for limit checking
      user_role: userRole, // Pass user role for limit checking
      class_type: item?.class_type,
    });
    setShowCancelModal(true);
  };

  const {
    mutate: rescheduleMentorCall,
    isLoading: isRescheduleMentorCallLoading,
  } = useRescheduleMentorCall(
    data => {
      setRescheduleSessionResponse(data);
      getWebinarDetails({ user_key: userKey, timezone: getUTCOffset() });
      const timer = setTimeout(() => {
        setShowRescheduleModal(false);
        clearTimeout(timer);
      }, 1000);
    },
    error => {
      setRescheduleSessionResponse(error);
    },
  );

  const { mutate: rescheduleSession, isLoading: isRescheduleSessionLoading } =
    useRescheduleSessionApi(
      data => {
        setRescheduleSessionResponse(data);
        getWebinarDetails({ user_key: userKey, timezone: getUTCOffset() });
        const timer = setTimeout(() => {
          setShowRescheduleModal(false);
          clearTimeout(timer);
        }, 1000);
      },
      error => {
        setRescheduleSessionResponse(error);
      },
    );

  const processAvailability = data => {
    const slots = data?.result?.[0]?.slots ?? [];

    // API sends times in IST - convert to user's local timezone for display
    const grouped = slots.reduce((acc, slot) => {
      // Convert IST times from API to user's local timezone
      const startTime = convertISTToUserTimezone(slot.start_time);
      const endTime = convertISTToUserTimezone(slot.end_time);

      // Extract date for grouping (in user's timezone)
      const dateKey = startTime.split('T')[0];

      console.log('Original IST:', slot.start_time);
      console.log('User TZ:', startTime);

      const timeSlot = {
        id: slot.id,
        start_time: startTime,
        end_time: endTime,
        is_available: slot.is_available,
        blocked_reason: slot.blocked_reason,
        original_start_time: slot.start_time,
      };

      if (!acc[dateKey]) {
        acc[dateKey] = [];
      }
      acc[dateKey].push(timeSlot);
      return acc;
    }, {});

    console.log('Grouped slots', grouped);
    setCoachAvailableSlots(grouped);
  };

  const { mutate: getCoachAvailability, isLoading: isCoachSlotsLoading } =
    useCoachAvailabilitySlots(
      data => processAvailability(data),
      error => {
        console.log(error, 'mentor calls error');
      },
    );
  const { mutate: getMentorAvailability, isLoading: isMentorSlotsLoading } =
    useGetAvailableSlots(
      data => processAvailability(data),
      error => {
        console.log(error, 'mentor calls error');
      },
    );

  const handleReschedule = (item: any) => {
    console.log(item, 'asdsf');
    setRescheduleSessionResponse(null);
    if (item?.id) {
      setShowRescheduleModal(true);
      setCallId(item.id);
      if (item.mentor_id) {
        getMentorAvailability({
          mentor_id: String(item.mentor_id),
          weeks: '2',
        });
        setIsMentorCall(true);
      } else if (item?.class_type == 'ptm' && item?.coach_user_id) {
        getCoachAvailability({
          coach_user_id: item.coach_user_id,
          reschedule_type: 'ptm',
          session_id: item.id,
        });
      } else if (item?.coach_user_id) {
        // For coach sessions, use 1-hour slots
        getCoachAvailability({
          coach_user_id: item.coach_user_id,
          reschedule_type: 'session',
          session_id: item.id,
        });
        setIsMentorCall(false);
      }
    }
  };

  const handleCancelConfirm = (sessionId: number, reason: string) => {
    if (cancelSessionData) {
      // Determine user role (for now defaulting to 'student', you may need to get this from context/props)
      const userRole =
        cancelSessionData.user_type === 'coach' ? 'coach' : 'student';

      cancelSession({
        session_id: sessionId,
        reason: reason,
        cancellation_type: cancelSessionData.cancellation_type,
        user_role: userRole,
      });
    }
  };

  const [enableClassroom, setEnableClassroom] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const fetchMeetings = () => {
    getWebinarDetails({ user_key: userKey, timezone: getUTCOffset() });
    lastFetchRef.current = Date.now();
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  const checkAndRefresh = () => {
    if (isFetchingRef.current) return;

    const diff = Date.now() - lastFetchRef.current;

    if (diff > TWO_HOURS) {
      isFetchingRef.current = true;

      fetchMeetings();

      lastFetchRef.current = Date.now();

      setTimeout(() => {
        isFetchingRef.current = false;
      }, 2000);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === 'visible') {
        checkAndRefresh();
      }
    }, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkAndRefresh();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const paginate = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      getWebinarDetails({
        page: pageNumber,
        user_key: userKey,
        timezone: getUTCOffset(),
      });
    }
  };

  const { isMobileOrTab, isTablet } = useMediaQuery();

  // Transform webinar item to join data format
  const transformToJoinData = (item: any) => ({
    id: item?.id,
    user_id: userData?.user_id,
    webinar_id: item?.webinar_id,
    registrant_token: item?.registrant_token,
    meeting_password: item?.meeting_password,
    occurence_id: item?.occurence_id,
    meeting_role: item?.meeting_role,
    is_zoom_meeting: item?.is_zoom_meeting,
    batch_type: item?.batch_type,
    class_type: item?.class_type,
    call_type: item?.call_type,
    webinar_topic: item?.topic,
    is_test_class: item?.is_test_class ?? false,
    join_url: item?.join_url,
  });
  const handleJoinPress = item => {
    // Just store the data temporarily and open the popup
    console.log(transformToJoinData(item), 'transformToJoinData(item)');

    setPendingJoinData(transformToJoinData(item));

    // setPopupIcon('');
    // setPopupQText('');
    // setPopupsubQText('');
    // setPopupCtaTitle1('');
    // setPopupCtaTitle2('');
    // setHighlightCta1(false);
    // setHighlightCta2(false);
    setRoute1(null);
    setRoute2(null);

    const popupSource = item?.popup_message
      ? item.popup_message
      : popupData
        ? popupData
        : null;
    if (popupSource) {
      setShowPopup(true);
      if (popupSource?.cta_details?.[0]?.action) {
        setRoute1(() => ROUTE_MAP[popupSource?.cta_details?.[0]?.action]);
        setAction1(popupSource?.cta_details?.[0]?.action);
      }
      if (popupSource?.cta_details?.[1]?.action) {
        setRoute2(() => ROUTE_MAP[popupSource?.cta_details?.[1]?.action]);
        setAction2(popupSource?.cta_details?.[1]?.action);
      }
      setPopupConfig({
        icon: ICON_MAP?.[popupSource?.icon]?.name || '',
        questionText: popupSource?.question_text || '',
        subQuestionText: popupSource?.sub_question || '',
        cta1: {
          text: popupSource?.cta_details?.[0]?.text || '',
          highlight: popupSource?.cta_details?.[0]?.highlight === 1,
          link: popupSource?.cta_details?.[0]?.link,
        },
        cta2: {
          text: popupSource?.cta_details?.[1]?.text || '',
          highlight: popupSource?.cta_details?.[1]?.highlight === 1,
          link: popupSource?.cta_details?.[1]?.link,
        },
        id: popupSource?.id,
      });
    } else {
      const joinData = transformToJoinData(item);
      const opened = handleJoinClick(joinData);
      if (opened === false) {
        setPopupBlocked(true);
      } else {
        setPendingJoinData(null);
      }
    }
  };
  const [upcomingTableData, setUpcomingTableData] = useState<
    Array<{
      data: Array<{
        name: string | JSX.Element;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>;
      isToday: boolean;
      itemId: string;
    }>
  >([]);

  const [pastTableData, setPastTableData] = useState<
    Array<{
      data: Array<{
        name: string | JSX.Element;
        type: 'text' | 'link' | 'dropdown';
        url?: string;
        options?: string[];
      }>;
      isToday: boolean;
      itemId: string;
    }>
  >([]);
  const handleStatusBarPress = () => {
    if (toRoute) {
      toRoute();
    } else if (statusBanner?.ctaAction === 'link') {
      window.open(statusBanner?.link, '_blank');
    } else {
      navigation.navigate(ScreenName?.Books, {
        tab: 'meeting',
      });
      setShowStatusBar(false);
    }
    popupAction({
      popup_id: statusBanner?.id,
      mobile_number: userContact,
      cta_action: statusBanner?.ctaAction,
    });
  };
  const handleRecordingPress = item => {
    const url = `${window.location.origin}/${ScreenName.Classroom}`;
    localStorage.setItem(
      'ZoomUserData',
      JSON.stringify({
        meetingId: item?.webinar_id,
        occurenceId: item?.occurence_id,
        meetingRole: 'student',
        videoId: item?.video_id,
        batchType: item.batch_type,
        topic: item.topic,
        recording_available: item?.recording_available,
        source: 'recording',
      }),
    );
    openInNewTab(url);
  };
  const handleViewDemo = (item, isZeroMeeting) => {
    const baseUrl = `${window.location.origin}/${ScreenName.Classroom}`;
    const url = baseUrl;
    console.log(isZeroMeeting, 'classroom......');
    localStorage.setItem(
      'ZoomUserData',
      JSON.stringify({
        meetingId: '95691',
        occurenceId: '176694',
        meetingRole: 'student',
        videoId: item?.video_id,
        batchType: item.class_type,
        topic: item.topic,
        recording_available: true,
        source: 'recording',
      }),
    );
    openInNewTab(url);
  };
  const WebinarSection = ({
    isLoading,
    webinarLoading,
    tableData,
    tabHeaders,
    currentPage,
    totalPages,
    paginate,
    webinarDetails,
    cardData,
    isMobileOrTab,
  }) => {
    if (isLoading) {
      return <CCLoader loading={isLoading} isComponentLoader />;
    }
    if (webinarLoading) {
      return <CCLoader loading bgWhite isComponentLoader />;
    }
    const customFlexArr = [0.9, 1.6, 1.6, 1, 1, 2];

    // "First 3 rows" is meant as the first 3 *class* rows — interleaved
    // tournament rows must not consume slots and silently cost a today-class
    // its highlight, so they are skipped when counting the window.
    let classRowsSeen = 0;
    const highlightedRows = tableData
      .map((row, idx) => {
        if (row.isTournament) {
          return -1;
        }
        classRowsSeen += 1;
        return classRowsSeen <= 3 && row.isToday ? idx : -1;
      })
      .filter(idx => idx !== -1);
    // Extract just the data for the table
    const tableDataFormatted = tableData.map(row => row.data || row);
    const criticalRows = tableData
      .map((row, idx) => (row.isCritical ? idx : -1))
      .filter(idx => idx !== -1);
    // CSOC tournament rows get their own tint so they read as a different
    // row type from the classes around them.
    const tournamentRows = tableData
      .map((row, idx) => (row.isTournament ? idx : -1))
      .filter(idx => idx !== -1);
    return (
      <Box flexDirection="column">
        {/* Renewal Banner */}
        {/* {showRenewalBanner && renewalData && (
          <Box paddingHorizontal={isMobileOrTab ? 10 : 20} marginBottom={15}>
            <RenewalBanner
              daysLeft={Number(
                renewalData?.current_subscription?.days_to_expiry || 100,
              )}
              couponDiscountPercentage={
                challengeState?.completed
                  ? challengeState.couponDiscount
                  : Number(renewalData?.coupon?.discount_value) ?? 0
              }
              expiryDate={renewalData?.current_subscription?.end_date}
              sessionsLeft={
                renewalData?.current_subscription?.sessions_left ?? 0
              }
              couponCode={
                challengeState?.completed
                  ? challengeState.couponCode
                  : renewalData?.coupon?.code
              }
              onClose={() => setShowRenewalBanner(false)}
              challengeCompleted={challengeState?.completed ?? false}
              onEarnDiscount={() =>
                navigation.navigate(ScreenName.RenewalPuzzleChallenge)
              }
            />
          </Box>
        )} */}
        {!isMobileOrTab && showStatusBar && !showTimezoneBanner && (
          <Box
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            style={[
              styles.statusBar,
              {
                backgroundColor: CCColors.Primary.Dark,
                marginHorizontal: 8,
              },
            ]}>
            <MeetingsBanner
              iconName={statusBanner?.icon}
              iconColor={CCColors.White}
              onClose={() => setShowStatusBar(false)}
              titleText={statusBanner?.title}
              ctaText={statusBanner?.ctaTitle}
              closeIcon={statusBanner?.closeIcon}
              handlePress={
                pausedOrderId ? handleResumeFromBanner : handleStatusBarPress
              }
              borderColor={statusBanner?.iconColor}
              subtitleText={statusBanner?.subTitle}
              highlight={statusBanner?.highlight}
              textColor={CCColors.White}
              isMobileOrTab={isMobileOrTab}
            />
          </Box>
        )}
        {tableData?.length > 0 && (
          <>
            <Box style={isMobileOrTab ? styles.mobileTable : styles.table}>
              <CCPackageTable
                headers={tabHeaders}
                tableData={tableDataFormatted ?? []}
                flexArr={customFlexArr}
                borderBottomColor={CCColors.BorderBottom}
                headerTextColor={CCColors.TextColor.Grey}
                margin={0}
                jsxTable={false}
                isMargin={false} // Enables Pressable rows
                tournament={false}
                backgroundColorRow={true}
                tableBorder={false}
                higlightedRow={
                  index === 0 && currentPage === 1 ? highlightedRows : null
                }
                highlightedBorder={false}
                tablePadding={true}
                headerHeight={55}
                tableShadow={true}
                customBlockRow={{
                  backgroundColor: CCColors.White,
                  borderColor: CCColors.BorderBottom,
                  padding: 0,
                }}
                customCellBlock={{
                  borderBottomWidth: 0,
                  padding: 0,
                }}
                isSecondLastRow={true}
                criticalRows={criticalRows}
                tournamentRows={tournamentRows}
                tournamentRowColor={TOURNAMENT_ROW_BG}
                isBorderBottomRow={true}
              />
            </Box>
            <Box
              style={{ alignSelf: 'flex-start', marginTop: 10, marginLeft: 10 }}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                paginate={paginate}
                activeColor={true}
              />
            </Box>
          </>
        )}
        {webinarDetails?.expired === 1 && (
          <Box style={{ alignItems: 'center', padding: 24, gap: 10 }}>
            <CCText
              style={{
                fontSize: 24,
                fontWeight: '500',
                lineHeight: 32,
                textAlign: 'center',
              }}>
              {webinarDetails?.display_message}
            </CCText>

            {webinarDetails?.renewal_web_link && (
              <CCButton
                style={{
                  paddingHorizontal: 20,
                  paddingVertical: 8,
                  borderRadius: 32,
                }}
                onPress={() =>
                  Linking.openURL(webinarDetails?.renewal_web_link)
                }>
                <CCText
                  style={{
                    fontSize: 16,
                    fontWeight: '500',
                    lineHeight: 24,
                    color: CCColors?.TextColor?.Dark,
                  }}>
                  Renew via web
                </CCText>
              </CCButton>
            )}

            {webinarDetails?.renewal_whatsapp_link && (
              <CCButton
                style={{
                  paddingHorizontal: 20,
                  paddingVertical: 8,
                  borderRadius: 32,
                }}
                onPress={() =>
                  Linking.openURL(webinarDetails?.renewal_whatsapp_link)
                }>
                <CCText
                  style={{
                    fontSize: 16,
                    fontWeight: '500',
                    lineHeight: 24,
                    color: CCColors?.TextColor?.Dark,
                  }}>
                  Renew via WhatsApp
                </CCText>
              </CCButton>
            )}
          </Box>
        )}
        {(webinarDetails?.expired === 0 ||
          webinarDetails?.csoc_subscription_status === -1) && (
            <EmptyView mobileNumber={userContact} activeTab={'meetings'} />
          )}
        {webinarDetails?.csoc_subscription_status === 3 && (
          <Box style={{ alignItems: 'center', padding: 24 }}>
            <Box
              alignItems="center"
              flexDirection="column"
              justifyContent="center"
              gap={4}
              style={styles.expiry4}>
              <CCText fontSize={FontSizes[14]} fontWeight={600}>
                Your classes will appear here soon 🎉
              </CCText>
              <Box
                alignItems="center"
                flexDirection="row"
                gap={4}
                justifyContent="center">
                <MaterialCommunityIcons
                  color={CCColors.Blue}
                  fontWeight={500}
                  name="information-outline"
                  size={20}
                />
                <CCText fontSize={FontSizes[12]} fontWeight={500}>
                  Your subscription is active, and your sessions are being
                  scheduled. You’ll see your upcoming classes here shortly.
                </CCText>
              </Box>
            </Box>
          </Box>
        )}
        {/* {showRenewalBanner && renewalData && userData?.is_staff && (
          <Box paddingHorizontal={isMobileOrTab ? 10 : 20} marginBottom={15}>
            <RenewalBanner
              daysLeft={renewalData?.current_subscription?.days_to_expiry}
              couponDiscountPercentage={
                Number(renewalData?.coupon?.discount_value) ?? 0
              }
              // daysLeft={-1}
              sessionsLeft={
                renewalData?.current_subscription?.sessions_left ?? 0
              } // This should come from API or be calculated
              couponCode={renewalData?.coupon?.code}
              onRenewNow={() => {
                navigation.navigate(ScreenName.Renewal, {userId});
              }}
              onClose={() => setShowRenewalBanner(false)}
            />
          </Box>
        )} */}
      </Box>
    );
  };

  const UpcomingWebinars = () => (
    <WebinarSection
      isLoading={isLoading || isWebinarLoading}
      webinarLoading={webinarLoading}
      tableData={upcomingTableData}
      tabHeaders={tabHeaders}
      currentPage={currentPage}
      totalPages={totalPages}
      paginate={paginate}
      webinarDetails={webinarDetails}
      cardData={cardData}
      isMobileOrTab={isMobileOrTab}
    />
  );

  const PastWebinars = () => (
    <WebinarSection
      isLoading={isLoading || isWebinarLoading}
      webinarLoading={webinarLoading}
      tableData={pastTableData}
      tabHeaders={tabHeaders}
      currentPage={currentPage}
      totalPages={totalPages}
      paginate={paginate}
      webinarDetails={webinarDetails}
      cardData={cardData}
      isMobileOrTab={isMobileOrTab}
    />
  );

  const renderScene = (rendererSceneProps: any) => {
    const { route: tempRoute } = rendererSceneProps;
    let returnJSX = <></>;

    switch (tempRoute.key) {
      case 'Meetings':
        return <PastWebinars />;
      case 'Upcoming Meetings':
        return <UpcomingWebinars />;
    }
  };

  // Upcoming CSOC tournament rows, formatted into the same 6-cell shape the
  // class rows use so they drop straight into the Upcoming table. The backend
  // (chatbot: csoc_tournament_eligibility.get_visible_csoc_tournaments) already
  // applies the level/region and class-conflict rules, so anything that arrives
  // here is meant to be shown as-is — no client-side filtering.
  // `todayOnly` builds the subset for the Meetings tab, which carries today's
  // sessions alongside past ones — a tournament happening today belongs there
  // too, not only under Upcoming.
  const formatTournamentRows = useCallback((todayOnly = false) => {
    if (!Array.isArray(tournamentData) || tournamentData.length === 0) {
      return [];
    }
    const user_timezone = userData?.user_timezone?.selected;
    const todayStr = dayjs().format('YYYY-MM-DD');
    const source = todayOnly
      ? tournamentData.filter(t => t?.webinar_date === todayStr)
      : tournamentData;
    return source.map(t => {
      // Field names mirror the webinar payload on purpose, so the same
      // timezone helper works with no special-casing.
      // It is NOT null-safe though: a missing webinar_date/webinar_time makes
      // its internal parseTime12h throw, and this runs inside the effect that
      // builds the table — an unguarded throw would blank the whole tab rather
      // than one row. Skip such a row instead.
      if (!t?.webinar_date || !t?.webinar_time) {
        return null;
      }
      const datetime = convertISTDateTimeToLocal(
        t?.webinar_date,
        t?.webinar_time,
        user_timezone,
      );
      const formattedLocalTimeRange = datetime?.localTimeRange ?? '';
      const [localTimeOnly, localTzSuffix] =
        formattedLocalTimeRange.split('GMT');
      const status = t?.status || 'Upcoming';
      const statusStyle = getStatusStyles(status);
      const goToTournament = () =>
        navigation.navigate(ScreenName.PlayChess, {
          tournamentId: t?.tournament_id,
          tournamentName: t?.name,
          // PlayChess auto-joins on arrival when this is true; the server-side
          // duplicate guard makes it safe for already-joined students, which is
          // why one button serves both states.
          isJoined: true,
        });

      // Styled to match the class rows' "Join" button — CCButton's default
      // yellow, with no colour override on the label.
      const actionButton = (
        <CCButton
          contentContainerStyle={{
            paddingHorizontal: 20,
          }}
          onPress={goToTournament}>
          <CCText fontWeight="semibold" fontSize={FontSizes[12]}>
            Play
          </CCText>
        </CCButton>
      );

      const statusPill = (
        <Box
          gap={10}
          style={[
            styles.session_link,
            {borderColor: statusStyle?.borderColor},
          ]}>
          <Box
            type="row-center"
            gap={10}
            style={[
              styles.zoom_box,
              {
                backgroundColor: statusStyle?.backgroundColor,
                padding: vs(8),
              },
            ]}>
            <CCText fontWeight="semibold" color={CCColors.Primary.Brown}>
              {status}
            </CCText>
          </Box>
        </Box>
      );

      const itemValues: any = [];
      // On mobile the whole row is drawn inside this first cell and every
      // later cell collapses to <></> — same convention as the class rows.
      itemValues.push({
        name: isMobileOrTab ? (
          // On mobile CCPackageTable renders block rows and ignores every
          // row-tint prop, so the distinct tournament colour has to be applied
          // here — this Box is the only thing that renders on mobile.
          <Box
            flexDirection="column"
            style={[
              styles.wrap,
              {backgroundColor: TOURNAMENT_ROW_BG},
            ]}>
            <Box
              flexDirection="row"
              justifyContent="space-between"
              gap={vs(8)}
              style={styles.padw}>
              <Box
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="center"
                style={{width: '70%'}}>
                <Box
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{flexWrap: 'nowrap', maxWidth: '90%'}}>
                  <CCText
                    showEllipses={true}
                    color={CCColors.Primary.Brown}
                    fontSize={FontSizes[18]}>
                    {t?.name}
                  </CCText>
                  <CCText
                    showEllipses={true}
                    color={CCColors.TextColor.GreyText}
                    fontWeight="regular"
                    fontSize={FontSizes[16]}>
                    {t?.organizer || 'CircleChess'}
                  </CCText>
                </Box>
                <Box
                  flexDirection="column"
                  gap={vs(3)}
                  style={{paddingTop: vs(8)}}>
                  <Box alignItems="flex-start" gap={5} flexDirection="row">
                    <MaterialCommunityIcons
                      name="clock-outline"
                      fontWeight={500}
                      size={FontSizes[18]}
                      color={CCColors.TextColor.GreyText}
                      style={{paddingTop: vs(2)}}
                    />
                    <CCText
                      fontWeight="medium"
                      color={CCColors.TextColor.GreyText}
                      fontSize={FontSizes[14]}>
                      {localTimeOnly || formattedLocalTimeRange}
                      {localTzSuffix ? '\n' : ''}
                      {localTzSuffix ? `GMT${localTzSuffix}` : ''}
                    </CCText>
                  </Box>
                  <Box alignItems="center" gap={5} flexDirection="row">
                    <MaterialCommunityIcons
                      fontWeight={500}
                      name="trophy"
                      size={FontSizes[18]}
                      color={CCColors.Primary.Default}
                    />
                    <CCText
                      fontWeight="medium"
                      color={CCColors.TextColor.GreyText}
                      fontSize={FontSizes[14]}>
                      {t?.class_type}
                    </CCText>
                  </Box>
                </Box>
              </Box>
              <Box style={styles.link} flexDirection="column" gap={7}>
                {statusPill}
                {actionButton}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box style={styles.dateCard}>
            <Box style={styles.monthbox}>
              <CCText
                color={CCColors.Grey.Grey}
                textAlign="center"
                fontWeight="medium">
                {dayjs(datetime?.localDate).format('MMM')}
              </CCText>
            </Box>
            <CCText
              textAlign="center"
              fontWeight="semibold"
              fontSize={FontSizes[12]}>
              {dayjs(datetime?.localDate).get('date')}
            </CCText>
          </Box>
        ),
        type: 'text',
      });
      // Tournament name + organizer
      itemValues.push({
        name: isMobileOrTab ? (
          <></>
        ) : (
          <Box
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
            gap={vs(2)}
            style={{
              paddingLeft: hs(8),
              paddingRight: vs(4),
              width: '100%',
              height: '100%',
            }}>
            <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
              {t?.name}
            </CCText>
            <CCText
              color={CCColors.Grey.Grey}
              fontWeight="semibold"
              fontSize={FontSizes[12]}>
              {t?.organizer || 'CircleChess'}
            </CCText>
          </Box>
        ),
        type: 'text',
      });
      // Time
      itemValues.push({
        name: isMobileOrTab ? (
          <></>
        ) : (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <Box
              type="row-flex-start"
              style={{margin: 'auto', width: '100%', flexWrap: 'wrap'}}>
              <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[12]}>
                {formattedLocalTimeRange}
              </CCText>
            </Box>
          </Box>
        ),
        type: 'text',
      });
      // Class Type — 'Arena' or 'Tournament', already resolved by the backend
      itemValues.push({
        name: isMobileOrTab ? (
          <></>
        ) : (
          <Box style={{padding: vs(12), width: '100%', height: '100%'}}>
            <Box
              type="row-flex-start"
              alignItems="center"
              gap={5}
              style={{margin: 'auto', width: '100%', flexWrap: 'wrap'}}>
              <MaterialCommunityIcons
                name="trophy"
                size={FontSizes[16]}
                color={CCColors.Primary.Default}
              />
              <CCText color={CCColors.Grey.Grey} fontSize={FontSizes[13]}>
                {t?.class_type}
              </CCText>
            </Box>
          </Box>
        ),
        type: 'text',
      });
      // Status
      itemValues.push({
        name: isMobileOrTab ? <></> : statusPill,
        type: 'text',
      });
      // Action
      itemValues.push({
        name: isMobileOrTab ? (
          <></>
        ) : (
          <Box
            alignItems="center"
            justifyContent="flex-start"
            style={{marginLeft: 18, flexWrap: 'wrap'}}
            flexDirection="row">
            {actionButton}
          </Box>
        ),
        type: 'link',
      });

      return {
        data: itemValues,
        isToday: false,
        itemId: `tournament_${t?.tournament_id}`,
        isCritical: false,
        isTournament: true,
        sortDate: datetime?.localDate,
      };
    });
  }, [tournamentData, isMobileOrTab, userData?.user_timezone?.selected]);

  useEffect(() => {
    if (
      (webinarData && Array.isArray(webinarData)) ||
      (pastWebinarData && Array.isArray(pastWebinarData)) ||
      (zeroMeetingData && Array.isArray(zeroMeetingData))
    ) {
      const itemsPerPage = 10;
      const zeroMeetingArray = Array.isArray(zeroMeetingData)
        ? zeroMeetingData
        : zeroMeetingData
          ? [zeroMeetingData]
          : [];
      const zeroData = (zeroMeetingArray || []).map(item => ({
        ...item,
        isPast: true,
        isZeroMeeting: true, // optional flag if you want special UI
      }));
      // const allData = [...pastWebinarData, ...webinarData];
      const pastData = [
        ...(zeroData.length ? zeroData : []),
        ...(pastWebinarData || [])?.map(item => ({ ...item, isPast: true })),
      ];
      const allData = [
        ...(webinarData || [])?.map(item => ({ ...item, isPast: false })),
      ];
      const webinars = index === 0 ? pastData : allData;
      const totalItems = webinars?.length;

      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const hasBeginnerClass = webinars?.some(
        item => item?.batch_type === 'Beginner',
      );
      setEnableClassroom(hasBeginnerClass);
      const paginatedData = webinars?.slice(startIndex, endIndex);
      // Identify today's webinars from ALL data, not just current page
      const todayStr = dayjs().format('YYYY-MM-DD');
      const todayIds = new Set<string>();
      const tomorrowStr = dayjs().add(1, 'day').format('YYYY-MM-DD');
      const tomorrowIds = new Set<string>();
      webinars?.forEach(item => {
        // Create unique key using webinar_id and (occurence not occurrence)_id
        const uniqueKey = `${item?.webinar_id || ''}_${item?.occurence_id || ''
          }`;
        if (item?.webinar_date === todayStr) {
          todayIds.add(uniqueKey);
        }
        if (item?.webinar_date === tomorrowStr) {
          tomorrowIds.add(uniqueKey);
        }
      });
      setTodayWebinarIds(todayIds);
      const formattedData = paginatedData?.map((item, index) => {
        const showRescheduleButton = new Date(item.end_time) > new Date();
        const disableCancel =
          !item?.is_zoom_meeting ||
          item?.call_type === 'demo_call' ||
          item?.webinar_date < new Date();
        const webinar_topic = item?.topic;
        const webinarCoach = item?.coach_name;
        const sessionNo = item?.session_number;
        const webinar_date = item?.webinar_date;
        const webinar_time = item?.webinar_time;
        const user_timezone = userData?.user_timezone?.selected;
        const webinar_url = item?.join_url;
        const isMeeting = item?.is_zoom_meeting || 0;
        const meeting_info = item?.meeting_info;
        const isStudent =
          item?.user_type !== 'coach' && item?.user_role !== 'mentor';
        const webinar_classtype = isStudent
          ? item?.class_type
          : item?.batch_code && item?.batch_code !== 'none'
            ? item?.batch_code
            : item?.class_type;
        const webinar_id = item?.webinar_id;
        const registrant_token = item?.registrant_token;
        const datetime = convertISTDateTimeToLocal(
          webinar_date,
          webinar_time,
          user_timezone,
        );
        const formattedLocalTimeRange = datetime?.localTimeRange ?? '';
        const [localTimeOnly, localTzSuffix] =
          formattedLocalTimeRange.split('GMT');
        const past_webinar_id = item?.id;
        const status = item?.status;

        // Determine actual status and tooltip for penalty sessions
        let displayStatus = status;
        let statusTooltip: string | null = null;

        // Check if session was held as penalty (cancelled late by student)
        if (item?.held_as_penalty) {
          displayStatus = 'missed';
          statusTooltip =
            'Late cancellation or cancellation limit exceeded - session still counted toward your subscription';
        }
        const meetingRole =
          item?.user_type === 'coach' || item?.user_role === 'mentor'
            ? 'coach'
            : 'student';
        setMeetingRole(meetingRole);
        const uniqueKey = `${item?.webinar_id || ''}_${item?.occurence_id || ''
          }`;
        const isGroupSession =
          (item?.call_type === 'meeting' || item?.call_type === 'webinar') &&
          item?.batch_code &&
          item?.batch_code !== 'none' &&
          !item?.batch_code?.toLowerCase()?.includes('-p-');
        const canCancel = !(isGroupSession && isStudent); // Students cannot cancel group sessions
        const shouldShowBottomBox =
          (webinar_url &&
            item?.showJoin &&
            registrant_token &&
            item?.status !== 'rescheduled') ||
          item?.recording_available ||
          (item.showJoin && registrant_token) ||
          (!disableCancel &&
            (item?.was_cancelled ||
              item?.finding_substitute ||
              (canCancel &&
                item?.is_zoom_meeting &&
                item?.call_type !== 'demo_call' &&
                item?.call_type !== 'mentor_call')));

        const isTodayMeeting = todayIds.has(uniqueKey);
        const isTomorrowMeeting = tomorrowIds.has(uniqueKey);
        const showJoin = isTomorrowMeeting || isTodayMeeting;
        const canShowJoinButton =
          (item?.isPast === true || showJoin) &&
          item?.showJoin &&
          item?.was_held !== true &&
          registrant_token;
        const isCritical = item?.is_critical;
        // The synthetic "Caissa walkthrough" row (see zeroMeetingData above) —
        // it has no real scheduled time or status, so those columns get
        // suppressed and the topic/coach line collapses to one short label.
        const isWalkthrough = !!item?.isZeroMeeting;
        let itemValues: any = [];
        // Date
        itemValues.push({
          name: isMobileOrTab ? (
            <Box flexDirection="column" style={styles.wrap}>
              <Box
                flexDirection="row"
                justifyContent="space-between"
                gap={vs(8)}
                style={styles.padw}>
                <Box
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent="center"
                  style={{
                    width: '70%',
                  }}>
                  <Box
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent="center"
                    style={{ flexWrap: 'nowrap', maxWidth: '90%' }}>
                    {isWalkthrough ? (
                      <CCText
                        showEllipses={true}
                        color={CCColors.Primary.Brown}
                        fontWeight="bold"
                        style={{letterSpacing: 0.4}}
                        fontSize={FontSizes[16]}>
                        PLATFORM WALKTHROUGH
                      </CCText>
                    ) : (
                      <>
                        <CCText
                          showEllipses={true}
                          color={CCColors.Primary.Brown}
                          fontSize={FontSizes[18]}>
                          {webinar_topic}
                        </CCText>
                        <CCText
                          showEllipses={true}
                          color={CCColors.TextColor.GreyText}
                          fontWeight={400}
                          fontSize={FontSizes[16]}>
                          {meetingRole === 'coach'
                            ? sessionNo
                              ? `Session Number : ${sessionNo}`
                              : ''
                            : `${webinarCoach}  ${isMeeting && sessionNo ? `| Session ${sessionNo}` : ''
                            } `}
                        </CCText>
                      </>
                    )}
                  </Box>
                  <Box
                    flexDirection="column"
                    gap={vs(3)}
                    style={{ paddingTop: vs(8) }}>
                    {!isWalkthrough && (
                      <Box alignItems="flex-start" gap={5} flexDirection="row">
                        <MaterialCommunityIcons
                          name="clock-outline"
                          fontWeight={500}
                          size={FontSizes[18]}
                          color={CCColors.TextColor.GreyText}
                          style={{
                            paddingTop: vs(2),
                          }}
                        />
                        <CCText
                          fontWeight={500}
                          color={CCColors.TextColor.GreyText}
                          fontSize={FontSizes[14]}>
                          {localTimeOnly || formattedLocalTimeRange}
                          {localTzSuffix ? '\n' : ''}
                          {localTzSuffix ? `GMT${localTzSuffix}` : ''}
                        </CCText>
                      </Box>
                    )}
                    <Box alignItems="center" gap={5} flexDirection="row">
                      <MaterialCommunityIcons
                        fontWeight={500}
                        name="desktop-mac"
                        size={FontSizes[18]}
                        color={CCColors.TextColor.GreyText}
                      />
                      <CCText
                        fontWeight={500}
                        color={CCColors.TextColor.GreyText}
                        fontSize={FontSizes[14]}>
                        {webinar_classtype}
                      </CCText>
                    </Box>
                  </Box>
                </Box>

                <Box style={styles.link} flexDirection="column">
                  <Box
                    gap={7}
                    flexDirection="column"
                    style={[
                      styles.session_link,
                      {
                        borderColor: getStatusStyles(status)?.borderColor,
                        paddingHorizontal: 0,
                      },
                    ]}>
                    {!isWalkthrough && (
                      <Box
                        type="row-center"
                        gap={10}
                        style={[
                          styles.zoom_box,
                          {
                            backgroundColor:
                              getStatusStyles(status)?.backgroundColor,
                            paddingHorizontal:
                              status === 'rescheduled' ? vs(8) : vs(15),
                            paddingVertical: vs(5),
                          },
                        ]}>
                        <CCText
                          fontWeight={600}
                          color={CCColors.Primary.Brown}>
                          {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
                        </CCText>
                      </Box>
                    )}
                    {!isWalkthrough && (
                      <Box style={[styles.datetime]}>
                        <Box style={[styles.monthbox, styles.monthboxsub]}>
                          <CCText
                            style={{
                              padding: vs(2),
                            }}
                            fontSize={FontSizes[15]}
                            color={CCColors.Grey.Grey}
                            textAlign="center"
                            fontWeight="500">
                            {dayjs(datetime?.localDate).format('MMM')}
                          </CCText>
                        </Box>
                        <CCText
                          style={{
                            padding: vs(5),
                          }}
                          textAlign="center"
                          fontWeight="500"
                          fontSize={FontSizes[18]}>
                          {dayjs(datetime?.localDate).get('date')}
                        </CCText>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
              {shouldShowBottomBox && (
                <Divider
                  width={0.5}
                  style={{
                    backgroundColor: CCColors.BorderLight,
                  }}
                />
              )}
              <Box
                flexDirection="row"
                justifyContent="space-between"
                style={{
                  paddingVertical: vs(8),
                  flexWrap: 'wrap',
                }}>
                {registrant_token || item?.recording_available ? (
                  <Box type="row-flex-start" style={styles.rec}>
                    {item?.isZeroMeeting ? (
                      <TouchableOpacity
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 6,
                        }}>
                        <CCButton
                          contentContainerStyle={styles.dark}
                          onPress={() => {
                            const isZeroMeeting = !!item?.isZeroMeeting;
                            handleViewDemo(item, isZeroMeeting);
                          }}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Watch
                          </CCText>
                        </CCButton>
                      </TouchableOpacity>
                    ) : item?.recording_available ? (
                      <TouchableOpacity
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 6,
                        }}>
                        <CCButton
                          contentContainerStyle={styles.dark}
                          onPress={() => handleRecordingPress(item)}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Relearn
                          </CCText>
                        </CCButton>
                      </TouchableOpacity>
                    ) : (
                      canShowJoinButton &&
                      item?.status !== 'rescheduled' &&
                      webinar_url && (
                        <TouchableOpacity style={styles.but}>
                          <CCButton
                            contentContainerStyle={{
                              paddingHorizontal: 70,
                            }}
                            disabled={item?.was_cancelled}
                            onPress={() => {
                              handleJoinPress(item);
                            }}>
                            <CCText fontWeight={600} fontSize={FontSizes[14]}>
                              Join
                            </CCText>
                          </CCButton>
                        </TouchableOpacity>
                      )
                    )}
                  </Box>
                ) : (
                  canShowJoinButton && (
                    <TouchableOpacity style={styles.but}>
                      <CCButton
                        contentContainerStyle={{
                          paddingHorizontal: 20,
                        }}
                        disabled={item?.was_cancelled}
                        onPress={() => {
                          handleJoinPress(item);
                        }}>
                        <CCText fontWeight={600} fontSize={FontSizes[12]}>
                          Join
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                  )
                )}

                <Box
                  alignItems="center"
                  justifyContent="center"
                  style={styles.reschedulebut}>
                  {showRescheduleButton &&
                    ((!item?.was_cancelled &&
                      item?.batch_code?.includes('-P-') &&
                      item?.user_type !== 'coach') ||
                      item?.call_type === 'mentor_call' ||
                      (item?.class_type == 'ptm' &&
                        item?.user_type !== 'coach')) && (
                      <TouchableOpacity
                        onPress={() => handleReschedule(item)}
                        disabled={item?.reschedules_remaining < 1}
                        style={styles.handle}>
                        <Box
                          flexDirection="row"
                          justifyContent="center"
                          alignItems="center"
                          gap={2}
                          style={[styles.reschedule]}>
                          <MaterialCommunityIcons
                            name="calendar-refresh-outline"
                            color={CCColors.Black}
                            size={17}
                          />
                        </Box>
                      </TouchableOpacity>
                    )}
                  {disableCancel ? (
                    <></>
                  ) : //  : item?.was_cancelled ? (
                    //   <Box
                    //     style={{
                    //       backgroundColor: CCColors.Grey.Light,
                    //       paddingHorizontal: 12,
                    //       paddingVertical: 6,
                    //       borderRadius: 16,
                    //     }}>
                    //     <CCText
                    //       fontSize={FontSizes[14]}
                    //       color={CCColors.Grey.Grey}>
                    //       Cancelled
                    //     </CCText>
                    //   </Box>
                    // )
                    item?.finding_substitute ? (
                      <Box style={styles.cancelIcon}>
                        <Icon
                          name="cancel"
                          size={24}
                          color={CCColors.Grey.Grey}
                        />
                      </Box>
                    ) : !canCancel ||
                      !item?.is_zoom_meeting ||
                      item?.call_type === 'demo_call' ||
                      item?.call_type === 'mentor_call' ? (
                      <></>
                    ) : (
                      <TouchableOpacity
                        onPress={() => handleCancelClick(item)}
                        style={styles.closeIcon}>
                        <Box
                          flexDirection="row"
                          justifyContent="center"
                          alignItems="center"
                          gap={2}
                          style={styles.cancel}>
                          <MaterialCommunityIcons
                            name="close-circle-outline"
                            color={CCColors.Red}
                            size={17}
                          />
                          {/* <CCText fontWeight={600} color={CCColors.Red}>
                          Cancel
                        </CCText> */}
                        </Box>
                      </TouchableOpacity>
                    )}
                </Box>
              </Box>
            </Box>
          ) : isWalkthrough ? (
            <></>
          ) : (
            <Box style={styles.dateCard}>
              <Box style={styles.monthbox}>
                <CCText
                  color={CCColors.Grey.Grey}
                  textAlign="center"
                  fontWeight="500">
                  {dayjs(datetime?.localDate).format('MMM')}
                </CCText>
              </Box>
              <CCText
                textAlign="center"
                fontWeight="600"
                fontSize={FontSizes[12]}>
                {dayjs(datetime?.localDate).get('date')}
              </CCText>
            </Box>
          ),
          type: 'text',
        });
        // Webinar Topic
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="center"
              gap={vs(2)}
              style={{
                paddingLeft: hs(8),
                paddingRight: vs(4),
                width: '100%',
                height: '100%',
              }}>
              {isWalkthrough ? (
                <CCText
                  color={CCColors.Primary.Brown}
                  fontWeight="bold"
                  style={{letterSpacing: 0.4}}
                  fontSize={FontSizes[13]}>
                  PLATFORM WALKTHROUGH
                </CCText>
              ) : (
                <>
                  <CCText
                    color={isCritical ? CCColors.White : CCColors.Grey.Grey}
                    fontSize={FontSizes[13]}>
                    {webinar_topic}
                  </CCText>
                  <CCText
                    color={isCritical ? CCColors.White : CCColors.Grey.Grey}
                    fontWeight={600}
                    fontSize={FontSizes[12]}>
                    {meetingRole === 'coach'
                      ? sessionNo
                        ? `Session Number : ${sessionNo}`
                        : ''
                      : `${webinarCoach}  ${isMeeting && sessionNo ? `| Session ${sessionNo}` : ''
                      } `}
                  </CCText>
                </>
              )}
            </Box>
          ),
          type: 'text',
        });
        // Time
        itemValues.push({
          name: isMobileOrTab || isWalkthrough ? (
            <></>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <CCText
                  color={isCritical ? CCColors.White : CCColors.Grey.Grey}
                  fontSize={FontSizes[12]}>
                  {datetime?.localTimeRange}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        // Class Type
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              style={{
                padding: vs(12),
                width: '100%',
                height: '100%',
              }}>
              <Box
                type="row-flex-start"
                alignItems="center"
                gap={5}
                style={{
                  margin: 'auto',
                  width: '100%',
                  flexWrap: 'wrap',
                  // justifyContent: 'row-center',
                }}>
                <MaterialCommunityIcons
                  name="monitor"
                  size={FontSizes[14]}
                  color={isCritical ? CCColors.White : CCColors.Grey.Grey}
                />
                <CCText
                  color={isCritical ? CCColors.White : CCColors.Grey.Grey}
                  fontSize={FontSizes[13]}>
                  {webinar_classtype}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });

        //Status
        itemValues.push({
          name: isMobileOrTab || isWalkthrough ? (
            <></>
          ) : statusTooltip ? (
            <Tooltip
              text={statusTooltip}
              backgroundColor={CCColors.Black}
              textcolor={CCColors.White}
              borderColor={CCColors.Black}
              arrowColor={CCColors.Black}
              fontSize={12}
              width={250}
              height={undefined}
              paddingVertical={8}
              borderWidth={1}
              children={toggleEvent => (
                <View onPointerEnter={toggleEvent} onPointerLeave={toggleEvent}>
                  <Box
                    gap={10}
                    type="row-center"
                    style={[
                      styles.session_link,
                      {
                        borderColor:
                          getStatusStyles(displayStatus)?.borderColor,
                      },
                    ]}>
                    <Box
                      type="row-center"
                      gap={10}
                      style={[
                        styles.zoom_box,
                        {
                          backgroundColor:
                            getStatusStyles(displayStatus)?.backgroundColor,
                          padding: vs(8),
                        },
                      ]}>
                      <CCText fontWeight={600} color={CCColors.Primary.Brown}>
                        {displayStatus?.charAt(0)?.toUpperCase() +
                          displayStatus?.slice(1)}
                      </CCText>
                    </Box>
                  </Box>
                </View>
              )}
            />
          ) : (
            <Box
              gap={10}
              style={[
                styles.session_link,
                {
                  borderColor: getStatusStyles(displayStatus)?.borderColor,
                },
              ]}>
              <Box
                type="row-center"
                gap={10}
                style={[
                  styles.zoom_box,
                  {
                    backgroundColor:
                      getStatusStyles(displayStatus)?.backgroundColor,
                    padding: vs(8),
                  },
                ]}>
                <CCText fontWeight={600} color={CCColors.Primary.Brown}>
                  {displayStatus?.charAt(0)?.toUpperCase() +
                    displayStatus?.slice(1)}
                </CCText>
              </Box>
            </Box>
          ),
          type: 'text',
        });
        // Actions (Cancel button or Cancelled tag)
        // Determine if cancel button should be shown
        // Group sessions: call_type is 'meeting' or 'webinar' AND batch_code doesn't contain '-p-'
        // Personal sessions: call_type is 'mentor_call' OR batch_code contains '-p-'
        itemValues.push({
          name: isMobileOrTab ? (
            <></>
          ) : (
            <Box
              alignItems="center"
              justifyContent="flex-start"
              style={{
                marginLeft: 18,
                flexWrap: 'wrap',
              }}
              flexDirection="row">
              <Box flexDirection="row" alignItems="center">
                {registrant_token || item?.recording_available ? (
                  <Box
                    style={{
                      height: '100%',
                    }}>
                    <Box
                      type="row-flex-start"
                      style={{
                        marginRight: 8,
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        alignItems: 'center',
                        // justifyContent: 'row-center',
                      }}>
                      {item?.isZeroMeeting ? (
                        <CCButton
                          contentContainerStyle={{
                            paddingHorizontal: 20,
                            backgroundColor: CCColors.Primary.Dark,
                          }}
                          onPress={() => {
                            const isZeroMeeting = !!item?.isZeroMeeting;
                            handleViewDemo(item, isZeroMeeting);
                          }}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Watch
                          </CCText>
                        </CCButton>
                      ) : item?.recording_available ? (
                        <CCButton
                          contentContainerStyle={{
                            paddingHorizontal: 20,
                            backgroundColor: CCColors.Primary.Dark,
                          }}
                          onPress={() => handleRecordingPress(item)}>
                          <CCText
                            color={CCColors.Primary.Default}
                            fontWeight={600}
                            fontSize={FontSizes[12]}>
                            Relearn
                          </CCText>
                        </CCButton>
                      ) : (
                        canShowJoinButton &&
                        item?.status !== 'rescheduled' &&
                        webinar_url && (
                          <TouchableOpacity
                            style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <CCButton
                              contentContainerStyle={{
                                paddingHorizontal: 20,
                              }}
                              disabled={item?.was_cancelled}
                              onPress={() => {
                                handleJoinPress(item);
                              }}>
                              <CCText fontWeight={600} fontSize={FontSizes[12]}>
                                Join
                              </CCText>
                            </CCButton>
                          </TouchableOpacity>
                        )
                      )}
                    </Box>
                  </Box>
                ) : (
                  canShowJoinButton && (
                    <TouchableOpacity style={styles.circle}>
                      <CCButton
                        contentContainerStyle={{
                          paddingHorizontal: 20,
                        }}
                        disabled={item?.was_cancelled}
                        onPress={() => {
                          handleJoinPress(item);
                        }}>
                        <CCText fontWeight={600} fontSize={FontSizes[12]}>
                          Join
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                  )
                )}
                {item?.status == 'cancelled' && item?.detail_reason && (
                  <CCButton
                    contentContainerStyle={styles.custom}
                    style={styles.cusbor}
                    onPress={() => {
                      openAlertModal({
                        bodyTxt: item?.detail_reason?.reason,
                        buttonText: 'Okay',
                        header: 'Reason',
                      });
                    }}>
                    <CCText color={CCColors.Black} fontWeight={600}>
                      View Detail
                    </CCText>
                  </CCButton>
                )}
              </Box>
              <Box
                alignItems="center"
                style={{
                  marginLeft: 8,
                  height: '100%',
                }}>
                <Box
                  alignItems="center"
                  justifyContent="center"
                  style={styles.tool}>
                  {showRescheduleButton &&
                    ((!item?.was_cancelled &&
                      item?.batch_code?.includes('-P-') &&
                      item?.user_type !== 'coach') ||
                      item?.call_type === 'mentor_call' ||
                      (item?.class_type == 'ptm' &&
                        item?.user_type !== 'coach')) && (
                      <Tooltip
                        text={
                          item?.class_type == 'ptm' &&
                            !item?.reschedules_remaining
                            ? 'Already rescheduled'
                            : 'Reschedule Session'
                        }
                        backgroundColor={CCColors.Black}
                        textcolor={CCColors.White}
                        borderColor={CCColors.Black}
                        arrowColor={CCColors.Black}
                        fontSize={12}
                        width={250}
                        height={undefined}
                        paddingVertical={8}
                        borderWidth={1}
                        children={toggleEvent => (
                          <View
                            onPointerEnter={toggleEvent}
                            onPointerLeave={toggleEvent}>
                            <TouchableOpacity
                              onPress={() => handleReschedule(item)}
                              disabled={item?.reschedules_remaining < 1}
                              style={[
                                styles.handle,
                                {
                                  cursor: 'pointer',
                                },
                              ]}>
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={styles.reschedule}>
                                <MaterialCommunityIcons
                                  name="calendar-refresh-outline"
                                  color={CCColors.Black}
                                  size={17}
                                />
                              </Box>
                            </TouchableOpacity>
                          </View>
                        )}
                      />
                    )}
                  {disableCancel ? (
                    <></>
                  ) : item?.finding_substitute ? (
                    <Box
                      style={[
                        styles.cancelIcon,
                        {
                          cursor: 'pointer',
                        },
                      ]}>
                      <Icon
                        name="cancel"
                        size={24}
                        color={CCColors.Grey.Grey}
                      />
                    </Box>
                  ) : !canCancel ||
                    !item?.is_zoom_meeting ||
                    item?.call_type === 'demo_call' ||
                    item?.call_type === 'mentor_call' ? (
                    <></>
                  ) : (
                    <Tooltip
                      text={'Cancel Session'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() => handleCancelClick(item)}
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            <Box
                              flexDirection="row"
                              justifyContent="center"
                              alignItems="center"
                              gap={2}
                              style={styles.cancel}>
                              <MaterialCommunityIcons
                                name="close-circle-outline"
                                color={CCColors.Red}
                                size={17}
                              />
                            </Box>
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                  {item?.assignment && (
                    <Tooltip
                      text={'Assignment'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() => {
                              navigation.navigate(ScreenName?.Books, {
                                tab: 'user_assignment',
                                name: item?.assignment?.name,
                                bookKey: item?.assignment?.book_key,
                                fromTab: 'meetings',
                              });
                            }}
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            {item?.assignment?.completed === true ? (
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={[
                                  styles.reschedule,
                                  {
                                    borderColor: CCColors.BlueAqua,
                                    backgroundColor:
                                      CCColors.StatusBar.BorderAquaBlue,
                                  },
                                ]}>
                                <Image
                                  source={bookOpen}
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box
                                flexDirection="row"
                                justifyContent="center"
                                alignItems="center"
                                gap={2}
                                style={[
                                  styles.reschedule,
                                  {
                                    borderColor: CCColors.Primary.Dark,
                                    backgroundColor: CCColors.Primary.Dark,
                                  },
                                ]}>
                                <Image
                                  source={bookCheck}
                                  style={{
                                    width: 16,
                                    height: 16,
                                  }}
                                />
                              </Box>
                            )}
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                  {item?.lms_chapter_link && (
                    <Tooltip
                      text={'Study Notes'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() =>
                              navigation.navigate(ScreenName?.Courses, {
                                directCourseId: item?.lms_chapter_link?.uuid, // Your course UUID
                                chapter: item?.lms_chapter_link?.chapter, // Your chapter ID
                                autoOpen: true, // Flag to auto-open iframe
                                returnUrl: `${window.location.origin}/resources?tab=meeting`,
                              })
                            }
                            style={[
                              styles.handle,
                              {
                                cursor: 'pointer',
                              },
                            ]}>
                            <Box
                              flexDirection="row"
                              justifyContent="center"
                              alignItems="center"
                              gap={2}
                              style={[
                                styles.reschedule,
                                {
                                  borderColor: CCColors.Primary.Dark,
                                  backgroundColor: CCColors.Primary.Dark,
                                },
                              ]}>
                              <MaterialCommunityIcons
                                size={16}
                                name="clipboard-text-outline"
                                color={CCColors.Primary.Default}
                              />
                            </Box>
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                  {item?.was_held === true && item?.feedback_status === 0 && (
                    <Tooltip
                      text={'Please Submit the class review!'}
                      backgroundColor={CCColors.Black}
                      textcolor={CCColors.White}
                      borderColor={CCColors.Black}
                      arrowColor={CCColors.Black}
                      fontSize={12}
                      width={250}
                      height={undefined}
                      paddingVertical={8}
                      borderWidth={1}
                      children={toggleEvent => (
                        <View
                          onPointerEnter={toggleEvent}
                          onPointerLeave={toggleEvent}>
                          <TouchableOpacity
                            onPress={() => {
                              setSelectedItem(item);
                              setShowReviewModal(true);
                            }}
                            style={{
                              marginLeft: 8,
                              width: 36,
                              height: 36,
                              borderRadius: 18,
                              backgroundColor: CCColors.Primary.Dark,
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}>
                            <Icon
                              name="star-outline"
                              size={18}
                              color={CCColors.Primary.Default}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          ),
          type: 'link',
        });
        return {
          data: itemValues,
          isToday: isTodayMeeting,
          itemId: uniqueKey,
          isCritical: isCritical,
          isTournament: false,
          // Used only to interleave tournament rows chronologically below.
          sortDate: datetime?.localDate,
        };
      });
      // Tournament rows ride on page 1 rather than joining the pagination
      // slice above — there are at most a handful and the page count stays
      // driven by classes.
      // `ascending` matches each tab's own ordering: Upcoming runs
      // oldest-first, Meetings runs newest-first.
      const mergeTournaments = (
        rows: any[],
        tournamentRowsRaw: any[],
        ascending: boolean,
      ) => {
        // formatTournamentRows returns null for a row it could not format
        // (missing date/time) — drop those rather than letting them reach the
        // table, where `row.data` would be read off null.
        const tournamentRows = (tournamentRowsRaw || []).filter(Boolean);
        const merged = [...(rows || []), ...tournamentRows];
        if (tournamentRows.length > 0) {
          // Interleave chronologically so a tournament sits between the
          // classes on either side of it instead of clumping at the bottom.
          merged.sort((a, b) => {
            const aDate = a?.sortDate ? dayjs(a.sortDate).valueOf() : 0;
            const bDate = b?.sortDate ? dayjs(b.sortDate).valueOf() : 0;
            if (!aDate || !bDate) {
              return 0;
            }
            return ascending ? aDate - bDate : bDate - aDate;
          });
        }
        return merged;
      };
      // At the end, set the appropriate state
      if (index === 0) {
        // The Meetings tab carries today's sessions as well as past ones, so a
        // tournament happening today belongs here too.
        setPastTableData(
          mergeTournaments(
            formattedData,
            currentPage === 1 ? formatTournamentRows(true) : [],
            false,
          ),
        );
      } else {
        setUpcomingTableData(
          mergeTournaments(
            formattedData,
            currentPage === 1 ? formatTournamentRows() : [],
            true,
          ),
        );
      }
    }
  }, [
    currentPage,
    isMobileOrTab,
    webinarData,
    pastWebinarData,
    index,
    tournamentData,
    formatTournamentRows,
  ]);

  const cardData = [
    {
      title: 'Live Classes',
      desc: 'Live IM/GM Classes',
      icon: require('@/Assets/Images/Meetings/Instructor.svg'),
    },
    {
      title: 'Coach',
      desc: 'Personalized training',
      icon: require('@/Assets/Images/Meetings/Coach.svg'),
    },
    {
      title: 'Mentor',
      desc: '1-on-1 Mentor Sessions',
      icon: require('@/Assets/Images/Meetings/Mentor.svg'),
    },
    {
      title: 'Practice',
      desc: 'Learn, compete, & grow',
      icon: require('@/Assets/Images/Meetings/Practice.svg'),
    },
  ];

  const handleFeedbackSubmitted = () => {
    setShowReviewModal(false);

    setTimeout(() => {
      setShowThankYouModal(true);
    }, 300);
  };

  return (
    <>
      <LinkModal
        showConfirm={showPopup}
        handleCtaTitle1Press={handleCTA1Press}
        errorMessage={undefined}
        handleCtaTitle2Press={handleCTA2Press}
        iconImage={
          <MaterialCommunityIcons
            name={popupConfig?.icon}
            color={CCColors.White}
            size={30}
          />
        }
        ctaTitle1={popupConfig?.cta1?.text}
        ctaTitle2={popupConfig?.cta2?.text}
        titleText={popupConfig?.questionText}
        description={popupConfig?.subQuestionText}
        highlight1={popupConfig?.cta1?.highlight}
        highlight2={popupConfig?.cta2?.highlight}
        handleClose={() => setShowPopup(false)}
        backgroundColor={ICON_MAP?.[popupData?.icon]?.bgColor}
        borderColor={ICON_MAP?.[popupData?.icon]?.bgColor}
      />
      {/* Renewal Modal */}
      <SlideModal
        visible={showRenewalModal}
        type="center"
        customStyle={{ justifyContent: 'center', alignItems: 'center' }}>
        <Box
          style={{
            // backgroundColor: 'white',
            // borderRadius: 12,
            // padding: 24,
            // // maxWidth: 400,
            // // width: '90%',
            // elevation: 5,
            position: 'relative',
          }}>
          {renewalModalData && (
            <RenewalExpiryModal
              days_to_expiry={renewalModalData.days_to_expiry}
              state={renewalModalData.state}
              onRenew={() => {
                navigation.navigate(ScreenName.Renewal, {
                  couponCode: challengeState?.couponCode,
                  couponDiscountPercentage: challengeState?.couponDiscount,
                });
                setShowRenewalModal(false);
              }}
              onClose={() => setShowRenewalModal(false)}
              couponCode={challengeState?.couponCode}
              couponDiscount={challengeState?.couponDiscount}
              couponExpiresAt={challengeState?.couponExpiresAt}
              onPuzzleChallenge={
                !(challengeState?.completed)
                  ? () => {
                    setShowRenewalModal(false);
                    navigation.navigate(ScreenName.RenewalPuzzleChallenge);
                  }
                  : undefined
              }
            />
          )}
        </Box>
      </SlideModal>
      <CCLoader loading={activeLoading || endLoading} />
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={{ flex: 1, padding: isMobileOrTab ? 10 : 20 }}>
        {showTimezoneBanner ? (
          <>
            <Box style={styles.timezoneBanner}>
              <Box
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                style={{ gap: 12 }}>
                <Box flexDirection="row" alignItems="center" gap={8}>
                  <MaterialCommunityIcons
                    name="alert-circle"
                    size={18}
                    color={CCColors.White}
                  />
                  <CCText
                    fontWeight="bold"
                    fontSize={FontSizes[14]}
                    color={CCColors.White}>
                    Meeting times look incorrect?
                  </CCText>
                </Box>

                <Box
                  flexDirection="row"
                  alignItems="center"
                  gap={8}
                  style={{ flexShrink: 0 }}>
                  <CCButton
                    onPress={handleSwitchTimezone}
                    disabled={isUpdatingProfile}
                    contentContainerStyle={{
                      paddingHorizontal: 14,
                      paddingVertical: 5,
                      minWidth: 84,
                    }}>
                    {isUpdatingProfile ? (
                      <ActivityIndicator
                        size="small"
                        color={CCColors.Primary.Brown}
                      />
                    ) : (
                      <CCText fontWeight="semibold" fontSize={FontSizes[11]}>
                        Switch Now
                      </CCText>
                    )}
                  </CCButton>
                  <TouchableOpacity
                    onPress={() => setShowTimezoneBanner(false)}
                    style={[styles.timezoneBannerClose, { cursor: 'pointer' }]}>
                    <MaterialCommunityIcons
                      name="close"
                      size={13}
                      color={CCColors.White}
                    />
                  </TouchableOpacity>
                </Box>
              </Box>

              <CCText
                fontSize={FontSizes[12]}
                color="rgba(255,255,255,0.85)"
                style={{
                  marginTop: 6,
                  lineHeight: 18,
                  maxWidth: isMobileOrTab ? '100%' : '85%',
                }}>
                Your profile's timezone doesn't match your current timezone,
                so class times may show incorrectly.
              </CCText>
            </Box>
            <Spacer spacing={vs(12)} />
          </>
        ) : (
          banner
        )}
        {sessionClick && (
          <SlideModal
            visible={sessionClick}
            type="center"
            customStyle={styles.reason}>
            <PopUp
              confirm={async () => {
                markWebinarHeld({ was_held: true, id: pastWebinarId });
                setSessionClick(false);
              }}
              text={'Are you sure you want to mark this session as held?'}
              buttonConfirm="Confirm"
              cancel={() => setSessionClick(false)}
            />
          </SlideModal>
        )}
        {showRestrictClassModal && (
          <SlideModal
            visible={showRestrictClassModal}
            type="center"
            customStyle={styles.reason}>
            <PopUp
              confirm={() => setShowRestrictClassModal(false)}
              text={showJoinStatusMessage}
              buttonConfirm="Okay"
            />
          </SlideModal>
        )}
        {showErrorAlert && (
          <SlideModal
            visible={showErrorAlert}
            type="center"
            customStyle={styles.reason}>
            <PopUp
              confirm={async () => {
                setShowErrorAlert(false);
              }}
              text={popupText}
              buttonConfirm="Okay"
            />
          </SlideModal>
        )}
        <Spacer spacing={vs(16)} />
        <Box
          type={isMobileOrTab ? 'column' : 'row-center-between'}
          style={{
            width: '100%',
          }}>
          {/* <CCLoader loading={isWebinarLoading} /> */}

          <TabView
            lazy
            // @ts-ignore
            navigationState={{ index: index, routes }}
            renderScene={renderScene}
            animationEnabled={false}
            renderTabBar={props => {
              const { navigationState } = props;
              const { index: activeIndex, routes } = navigationState;

              return (
                <Box
                  justifyContent="flex-start"
                  flexDirection={isMobileOrTab ? 'column' : 'row'}
                  gap={isMobileOrTab && 20}
                  style={{
                    marginBottom: 18,
                  }}>
                  <Box>
                    <CCText fontSize={24} color={CCColors.Primary.Dark}>
                      Meetings
                    </CCText>
                  </Box>
                  {showStatusBar && isMobileOrTab && !showTimezoneBanner && (
                    <LinearGradient
                      colors={['#E17846', '#e0850f']}
                      start={{ x: 1, y: 0 }}
                      end={{ x: 0, y: 0 }}
                      style={styles.grad}>
                      <MeetingsBanner
                        backgroundColor={statusBanner?.iconBg}
                        iconName={statusBanner?.icon}
                        iconColor={statusBanner?.iconColor}
                        onClose={() => setShowStatusBar(false)}
                        titleText={statusBanner?.title}
                        ctaText={statusBanner?.ctaTitle}
                        closeIcon={statusBanner?.closeIcon}
                        handlePress={
                          pausedOrderId ? handleResumeFromBanner : handleStatusBarPress
                        }
                        borderColor={statusBanner?.iconColor}
                        subtitleText={statusBanner?.subTitle}
                        highlight={statusBanner?.highlight}
                        textColor={CCColors.White}
                        isMobileOrTab={isMobileOrTab}
                      />
                    </LinearGradient>
                  )}
                  <Box
                    flexDirection="row"
                    alignItems="center"
                    // justifyContent="flex-end"
                    style={{
                      width: '90%',
                      justifyContent: 'flex-end',
                    }}
                    gap={8}>
                    <TabBar
                      {...props}
                      indicatorStyle={{
                        width: '50%',
                        height: '100%',
                        backgroundColor: CCColors.Primary.Brown,
                        borderTopLeftRadius:
                          props?.navigationState?.index === 0 ? 8 : 0, // Rounded for first tab
                        borderBottomLeftRadius:
                          props?.navigationState?.index === 0 ? 8 : 0,
                        borderTopRightRadius:
                          props?.navigationState?.index ===
                            props?.navigationState?.routes?.length - 1
                            ? 8
                            : 0, // Rounded for last tab
                        borderBottomRightRadius:
                          props?.navigationState?.index ===
                            props?.navigationState?.routes?.length - 1
                            ? 8
                            : 0,
                      }}
                      style={[
                        styles.ner,
                        {
                          width: isMobileOrTab ? '100%' : '33%',
                        },
                      ]}
                      contentContainerStyle={{
                        height: 32, // Set the height for the tablist
                      }}
                      renderLabel={({ route, focused, ...rest }) => {
                        const totalItems =
                          props?.navigationState?.routes?.length;
                        const itemId =
                          props?.navigationState?.routes?.findIndex(
                            i => i?.key === route?.key,
                          );

                        return (
                          <CCText
                            fontSize={FontSizes[12]}
                            fontWeight="semibold"
                            style={[
                              styles.boxTabBarLabel,
                              focused ? styles.boxIndicator : {},
                              {
                                color: focused
                                  ? CCColors?.White
                                  : CCColors?.TextColor?.Primary,
                              },
                              itemId === 0
                                ? styles.boxLeftBorder
                                : itemId === totalItems - 1
                                  ? styles.boxRightBorder
                                  : null,
                            ]}>
                            {route.title}
                          </CCText>
                        );
                      }}
                      tabStyle={styles.index}
                    />
                  </Box>
                </Box>
              );
            }}
            onIndexChange={index => {
              setIsTabChanging(true);
              setIndex(index);
              setCurrentPage(1);
            }}
          />

          {isMobileOrTab && <Spacer spacing={10} />}
        </Box>
        <Spacer spacing={vs(20)} />
      </ScrollView>
      <ActiveMeetingsModal
        visible={showActiveMeetingsModal}
        activeMeetingsCount={activeMeetingsCount || 0}
        onClose={handleModalClose}
        onJoin={handleModalJoin}
        onEndAndJoin={handleModalEndAndJoin}
      />
      <CancelSessionModal
        visible={showCancelModal}
        sessionData={cancelSessionData}
        onClose={() => {
          setShowCancelModal(false);
          setCancelSessionData(null);
        }}
        onConfirm={handleCancelConfirm}
        isLoading={isCancelling}
        userRole={userRole}
      />
      <RescheduleModal
        visible={showRescheduleModal}
        onClose={() => {
          setShowRescheduleModal(false);
          setCallId('');
        }}
        isLoading={
          isMentorCall
            ? isMentorSlotsLoading || isRescheduleMentorCallLoading
            : isCoachSlotsLoading || isRescheduleSessionLoading
        }
        availableSlots={coachAvailableSlots}
        isHost={userData.is_mentor}
        callId={callId}
        onReschedule={isMentorCall ? rescheduleMentorCall : rescheduleSession}
        userTimezone={userTimezone}
        apiResponse={rescheduleSessionResponse}
      />
      <SupportModal
        openModal={showModal}
        handleClose={() => setShowModal(false)}
      />
      <ClassReviewModal
        visible={showReviewModal}
        onClose={() => setShowReviewModal(false)}
        topic={selectedItem?.topic}
        coachName={selectedItem?.coach_name}
        webinarId={selectedItem?.id}
        userData={userData}
        onSubmit={handleFeedbackSubmitted}
      />
      <ThankYouModal
        visible={showThankYouModal}
        onClose={() => { setShowThankYouModal(false); fetchMeetings(); }}
      />
    </>
  );
};

const styles = StyleSheet.create({
  timezoneBanner: {
    width: '100%',
    borderRadius: 8,
    backgroundColor: CCColors.Primary.Dark,
    paddingHorizontal: 14,
    paddingVertical: 10,
    shadowColor: CCColors.Primary.Dark,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.12,
    shadowRadius: 6,
    elevation: 2,
  },
  timezoneBannerClose: {
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  boxLeftBorder: {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
  boxRightBorder: {
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
  boxIndicator: {
    // backgroundColor: CCColors?.Primary.Brown,
    height: '0%',
    marginBottom: 20,
    // borderRadius: 8,
  },
  boxTabBarLabel: {
    color: CCColors?.White,
    paddingBottom: 55,
    // borderWidth: StyleSheet.hairlineWidth,
  },
  statusBar: {
    paddingVertical: '0.5%',
    borderRadius: 8,
  },
  dateCard: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    padding: vs(4),
    marginLeft: vs(25),
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#26232233',
    shadowColor: '#4D3F370D',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
    marginVertical: vs(5),
  },
  monthbox: {
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 4,
    width: '100%',
    marginBottom: vs(4),
  },
  session_link: {
    borderWidth: 0,
    borderColor: '#67B3E180',
    borderRadius: 4,
    paddingVertical: vs(6),
    paddingHorizontal: vs(10),
    color: CCColors.Primary.Dark,
  },
  zoom_box: {
    backgroundColor: '#67B3E126',
    borderRadius: 4,
    paddingVertical: vs(10),
    paddingHorizontal: vs(15),
    color: CCColors.Primary.Dark,
  },
  table: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    shadowColor: CCColors.Black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 6,
    margin: 10,
    overflow: 'hidden',
  },
  mobileTable: {
    backgroundColor: CCColors.CCTableBg,
    borderRadius: 8,
    margin: 0,
    overflow: 'hidden',
  },
  cancel: {
    paddingHorizontal: vs(10),
    paddingVertical: vs(10),
    borderRadius: 25,
    borderWidth: 1,
    borderColor: '#E1784680',
    backgroundColor: CCColors.White,
  },
  reschedule: {
    borderColor: CCColors.BorderBottom,
    paddingHorizontal: vs(10),
    paddingVertical: vs(10),
    borderRadius: 25,
    borderWidth: 1,
    backgroundColor: CCColors.White,
  },
  wrap: {
    width: '100%',
    paddingHorizontal: vs(17),
    paddingTop: vs(10),
  },
  padw: {
    paddingVertical: vs(12),
    width: '100%',
  },
  link: {
    width: '30%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  datetime: {
    backgroundColor: CCColors.White,
    borderRadius: 8,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: CCColors.ShadowBorder,
    shadowColor: CCColors.Shadow,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
  },
  monthboxsub: {
    marginTop: vs(3),
    marginHorizontal: vs(3),
    width: '95%',
  },
  rec: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dark: {
    paddingHorizontal: 70,
    backgroundColor: CCColors.Primary.Dark,
  },
  but: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 6,
  },
  reschedulebut: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
  },
  handle: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  cancelIcon: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
    opacity: 0.5,
  },
  closeIcon: {
    padding: 6,
    borderRadius: 4,
    backgroundColor: 'transparent',
  },
  circle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  custom: {
    paddingHorizontal: 20,
    backgroundColor: CCColors.White,
  },
  cusbor: {
    borderColor: '#b6b3b3',
    borderWidth: 1,
  },
  tool: {
    margin: 'auto',
    width: '100%',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
  },
  reason: {
    borderRadius: 12,
    backgroundColor: 'white',
    zIndex: 5,
    overflowY: 'hidden',
    minWidth: '20%',
    margin: 'auto',
  },
  grad: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: 1,
    borderColor: CCColors.Primary.Brown,
    overflow: 'hidden',
    borderRadius: 8,
  },
  ner: {
    backgroundColor: CCColors?.White,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: CCColors.Grey.Border,
    padding: 0,
    borderRadius: 8,
  },
  index: {
    flex: 1,
    height: '100%',
    paddingTop: 45,
    alignItems: 'center',
    justifyContent: 'center',
    borderRightWidth: 2,
    borderRightColor: CCColors.BorderLight,
  },
  row: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 10,
    padding: 8,
    alignItems: 'center',
  },
  expiry4: {
    borderWidth: 0.5,
    borderColor: CCColors.Blue,
    borderRadius: 10,
    marginBottom: 10,
    padding: 10,
  },
  //  Thankyou modal styles
  container: {
    padding: 22,
    alignItems: 'center',
  },
  iconWrapper: {
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: CCColors.BorderLight,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 14,
  },
  title: {
    fontWeight: '700',
    marginBottom: 6,
    color: CCColors.TextColor.Primary,
  },
  subtitle: {
    textAlign: 'center',
    color: CCColors.TextColor.Grey,
    lineHeight: 20,
  },
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: CCColors.BorderLight,
    marginVertical: 16,
  },
  note: {
    fontSize: FontSizes[12],
    color: CCColors.TextColor.Grey,
    textAlign: 'center',
    marginBottom: 16,
  },
  button: {
    width: '100%',
  },
});

export default Meetings;
